import * as Sentry from '@sentry/react';
import { readFromLocalStorage, removeTreeLevel } from "../services/localStorage";
import { STORAGE_KEYS } from "../constants/storageKeys";
import type { TreeLevelState } from "../types/redux";

const STORE_VERSION = 2;

interface PersistedTreeLevel extends TreeLevelState {
    _storeVersion: number;
}

export const loadData = (): TreeLevelState | undefined => {
    try {
        const serialTree = readFromLocalStorage(STORAGE_KEYS.TREE_LEVEL) as PersistedTreeLevel | null;
        if (serialTree === null) return undefined;

        if (serialTree._storeVersion !== STORE_VERSION) {
            removeTreeLevel();
            return undefined;
        }

        return serialTree;
    } catch (err) {
        Sentry.captureException(err);
        return undefined;
    }
}
